import React from 'react';
import styles from './WhatWeOffer.module.css';

const WhatWeOffer = ({ onNavigate }) => {
  const services = [
    {
      id: 'cosy-stays',
      title: 'Cosy Stays',
      description: 'Beautifully appointed rooms combining period features with modern amenities. Perfect for a weekend getaway or business travel.',
      image: '/website_images/reggie_room1.jpg',
      isExternal: false,
      isInternal: true,
      internalRoute: 'rooms'
    },
    {
      id: 'welcoming-bar',
      title: 'Welcoming Bar',
      description: 'Carefully curated selection of local and regional ales, plus an extensive wine list and premium spirits. Something for every taste.',
      image: '/website_images/bar_taps.jpg',
      isExternal: false,
      isInternal: true,
      internalRoute: 'welcoming-bar'
    },
    {
      id: 'tasty-bites',
      title: 'Tasty Bites',
      description: 'Hearty British classics made with locally sourced ingredients. From fish & chips to shepherd\'s pie, every dish tells a story of culinary tradition.',
      image: '/website_images/food_burger.jpg',
      isExternal: false,
      isInternal: true,
      internalRoute: 'tasty-bites'
    },
    {
      id: 'pets',
      title: 'P-awesome Pets',
      description: 'We welcome well-behaved furry friends! Your four-legged companions are part of the family and can enjoy our pet-friendly facilities.',
      image: '/website_images/dog_friendly_pups.jpg',
      isExternal: false,
      isInternal: true,
      internalRoute: 'pets'
    },
    {
      id: 'award-winners',
      title: 'Award Winners',
      description: 'We\'re proud to be winners of Channel 4\'s "Four in a Bed" competition, showcasing the very best of Welsh hospitality and our commitment to exceptional guest experiences.',
      image: '/website_images/4_bed_black.jpg',
      isExternal: true,
      externalUrl: 'https://www.channel4.com/programmes/four-in-a-bed/on-demand/73588-062'
    },
    {
      id: 'local-area',
      title: 'Local Area',
      description: 'Explore historic Harlech Castle, beautiful beaches, and Snowdonia National Park. From medieval history to stunning coastal walks, there\'s something for everyone.',
      image: '/website_images/area_castle.jpg',
      isExternal: false,
      isInternal: true,
      internalRoute: 'area'
    },
    {
      id: 'whats-on',
      title: 'What\'s On',
      description: 'Stay up to date with our latest events, live music, quiz nights, and special occasions. From intimate acoustic sessions to lively community gatherings, there\'s always something happening at The Queens.',
      image: '/website_images/whats_on2.jpg',
      isExternal: false,
      isInternal: true,
      internalRoute: 'welcoming-bar',
      scrollTo: 'whats-on'
    },
    {
      id: 'private-events',
      title: 'Private Events',
      description: 'Make your special occasion unforgettable with our private event spaces. Whether it\'s a birthday celebration, anniversary, or business meeting, we\'ll help you create the perfect atmosphere.',
      image: '/website_images/private_events.jpg',
      isExternal: false,
      isInternal: true,
      internalRoute: 'private-events'
    },
    {
      id: 'our-story',
      title: 'Our Story',
      description: 'Discover the rich history and heritage of The Queens Hotel. From its origins as a traditional Welsh inn to its transformation into a modern family-run establishment, every corner tells a story.',
      image: '/website_images/our_story.jpg',
      isExternal: false,
      isInternal: true,
      internalRoute: 'story'
    }
  ];

  const Card = ({ service }) => {
    const cardContent = (
      <>
        <div 
          className={styles['card-image']} 
          style={{ backgroundImage: `url(${service.image})` }}
          aria-label={`${service.title} image`}
        ></div>
        <div className={styles['card-content']}>
          <h3>{service.title}</h3>
          <p>{service.description}</p>
          {(service.isInternal || service.isExternal) && (
            <div className={styles['see-more']}>
              {service.id === 'award-winners' ? 'Watch episode' : 'See more'}
            </div>
          )}
        </div>
      </>
    );

    if (service.isExternal) {
      return (
        <a 
          href={service.externalUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={`${styles.card} ${styles['external-link']}`}
          data-testid={`card-${service.id}`}
          aria-label={`${service.title} - opens in new tab`}
        >
          {cardContent}
        </a>
      );
    }

    if (service.isInternal) {
      return (
        <div 
          className={`${styles.card} ${styles['internal-link']}`}
          data-testid={`card-${service.id}`}
          onClick={() => onNavigate && onNavigate(service.internalRoute, service.scrollTo)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onNavigate && onNavigate(service.internalRoute, service.scrollTo);
            }
          }}
          aria-label={`${service.title} - view details`}
        >
          {cardContent}
        </div>
      );
    }

    return (
      <div className={styles.card} data-testid={`card-${service.id}`}>
        {cardContent}
      </div>
    );
  };

  return (
    <div className={styles['what-we-offer']}>
      <div className={styles.container}>
        <div className={styles.section}>
          <h2 className={styles['section-title']}>What We Offer</h2>
          <div className={styles.cards} data-testid="cards-container">
            {services.map((service) => (
              <Card key={service.id} service={service} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhatWeOffer;